import useTheme from "@mui/material/styles/useTheme";
import React, { useId } from "react";

export default function LessonLockIcon() {
  const theme = useTheme();
  const uniqueId = useId();
  const maskId = `path-2-inside-1_10757_10542-${uniqueId}`;
  const color = theme.palette.mode === "dark" ? "#74777A" : "#8E9193";
  
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
      <rect x="2.665" y="6.665" width="10.67" height="7.17" rx="1.335" stroke={color} strokeWidth="1.33" />
      <mask id={maskId} fill="white">
        <path d="M8 1.5C9.933 1.5 11.5 3.067 11.5 5V7H4.5V5C4.5 3.067 6.067 1.5 8 1.5Z" />
      </mask>
      <path
        d="M11.5 5H12.83H11.5ZM11.5 7V8.33H12.83V7H11.5ZM4.5 7H3.17V8.33H4.5V7ZM4.5 5H3.17H4.5ZM8 1.5V2.83C9.19846 2.83 10.17 3.80154 10.17 5H11.5H12.83C12.83 2.33246 10.6675 0.17 8 0.17V1.5ZM11.5 5H10.17V7H11.5H12.83V5H11.5ZM11.5 7V5.67H4.5V7V8.33H11.5V7ZM4.5 7H5.83V5H4.5H3.17V7H4.5ZM4.5 5H5.83C5.83 3.80154 6.80154 2.83 8 2.83V1.5V0.17C5.33246 0.17 3.17 2.33246 3.17 5H4.5Z"
        fill={color}
        mask={`url(#${maskId})`}
      />
      <rect x="7.5" y="8.25" width="1" height="3" rx="0.5" fill={color} />
    </svg>
  );
}
